import React from 'react'

import { Icon } from '@clientbase/clientbase-library'
import { Tooltip, useMediaQuery } from '@mui/material'

import { theme } from 'styles/theme'

import * as S from './Info.styles'

type InfoItemProps = {
  title: string
  data: number | string
  children?: React.ReactNode
  tooltipTitle?: string
  isPercentage?: boolean
}

const InfoItem = ({
  title,
  data,
  children,
  tooltipTitle,
  isPercentage
}: InfoItemProps) => {
  const isMobile = useMediaQuery('(max-width:560px)')

  return (
    <S.CardWrapper isPercentage={isPercentage}>
      <S.CardHeader>
        <S.CardTitle>{title}</S.CardTitle>
        {tooltipTitle && (
          <Tooltip
            arrow
            placement={isMobile ? 'top' : 'right'}
            title={tooltipTitle}
          >
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <Icon icon="info" size={2} colorSX={theme.palette.neutral[500]} />
            </div>
          </Tooltip>
        )}
      </S.CardHeader>
      <S.CardValue>{data}</S.CardValue>
      {children}
    </S.CardWrapper>
  )
}

export default InfoItem
